import Swal from 'sweetalert2';
import { fetchRequestStatus } from '../services/comersRequestFlow';
import {
  buildSwalBody,
  getRequestRejectionDetail,
  getRequestStatusMessage,
  isRequestBlocked,
  showRequestBlockedAlert
} from './requestStatusGuard';

export const normalizeRequestStatus = (response) =>
  response?.data?.requestStatus ??
  response?.requestStatus ??
  response?.data ??
  response;

export const showStatusVerificationError = () =>
  Swal.fire({
    icon: 'error',
    title: 'No fue posible continuar',
    text: 'No pudimos verificar el estado de la solicitud. Volvé a intentar.',
    confirmButtonText: 'Entendido',
    allowOutsideClick: false,
    allowEscapeKey: false
  });

export const showMissingRequestUidError = () =>
  Swal.fire({
    icon: 'error',
    title: 'No fue posible continuar',
    text: 'No se pudo identificar la solicitud seleccionada.',
    confirmButtonText: 'Entendido',
    allowOutsideClick: false,
    allowEscapeKey: false
  });

export async function guardRequestContinuation({
  requestUid,
  onAllowed,
  onViewRequests,
  onFatalError
}) {
  if (!requestUid) {
    await showMissingRequestUidError();
    onFatalError?.();

    return {
      allowed: false,
      reason: 'missing_request_uid'
    };
  }

  let requestStatus;

  try {
    const response = await fetchRequestStatus(requestUid);
    requestStatus = normalizeRequestStatus(response);
  } catch (error) {
    await showStatusVerificationError();
    onFatalError?.(error);

    return {
      allowed: false,
      reason: 'status_check_failed'
    };
  }

  if (isRequestBlocked(requestStatus)) {
    showRequestBlockedAlert({
      message: getRequestStatusMessage(requestStatus),
      detail: getRequestRejectionDetail(requestStatus),
      onViewRequests,
      onFatalError
    });

    return {
      allowed: false,
      reason: 'request_blocked',
      requestStatus
    };
  }

  try {
    await onAllowed?.(requestStatus);
  } catch (error) {
    onFatalError?.(error);

    return {
      allowed: false,
      reason: 'on_allowed_failed',
      requestStatus
    };
  }

  return {
    allowed: true,
    requestStatus
  };
}

const getBlockedReasonAlertTitle = (status) => {
  const normalizedStatus = Number(status);

  if (normalizedStatus === 3 || normalizedStatus === 4) {
    return 'Motivo del rechazo';
  }

  return 'Detalle de la solicitud';
};

export async function showRequestBlockedReason(requestUid) {
  if (!requestUid) {
    await showMissingRequestUidError();

    return {
      success: false,
      reason: 'missing_request_uid'
    };
  }

  try {
    const response = await fetchRequestStatus(requestUid);
    const requestStatus = normalizeRequestStatus(response);

    const message = getRequestStatusMessage(requestStatus);
    const detail = getRequestRejectionDetail(requestStatus);

    await Swal.fire({
      icon: 'info',
      title: getBlockedReasonAlertTitle(requestStatus?.status),
      ...buildSwalBody(message, detail),
      confirmButtonText: 'Entendido',
      allowOutsideClick: true
    });

    return {
      success: true,
      requestStatus
    };
  } catch (error) {
    await showStatusVerificationError();

    return {
      success: false,
      reason: 'status_check_failed'
    };
  }
}
